import { configureStore } from '@reduxjs/toolkit'
import MySlice from './services/Reducer'

export default configureStore({
  reducer: {
    ReducerData:MySlice
  },
})